import makeBem from "Utils/makeBem";

export const bem = makeBem("ComparePlans");
